import { render, staticRenderFns } from "./OrganizationListMdt.vue?vue&type=template&id=c6c01b04&scoped=true"
import script from "./OrganizationListMdt.vue?vue&type=script&lang=js"
export * from "./OrganizationListMdt.vue?vue&type=script&lang=js"
import style0 from "./OrganizationListMdt.vue?vue&type=style&index=0&id=c6c01b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c01b04",
  null
  
)

export default component.exports